import { ModulesConfigMap, ModulesMap } from '../data/modulesMaps'

export default {
  getReportsServicePayments: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.REPORTS_SERVICE_PAYMENTS].GET_REPORTS_SERVICE_PAYMENTS,
  },
  getReportsServicePayment: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.REPORTS_SERVICE_PAYMENTS].GET_REPORTS_SERVICE_PAYMENT,
  },
  getReportsServicePaymentPreview: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.REPORTS_SERVICE_PAYMENTS].GET_REPORTS_SERVICE_PAYMENT_PREVIEW,
  },
}